import Skeleton from "./skeleton.component.js";

export default angular
    .module("oui.skeleton", [])
    .component("ouiSkeleton", Skeleton)
    .name;
